import AdminPermissionContainer from 'Admin/Container/AdminPermissionContainer';

export default AdminPermissionContainer;
